import { fetchCartSummary } from 'helpers/api';
import { formatMoney } from 'helpers/utils';

const hide = 'ob__level--hide';

// DOM lookups are resolved lazily (per-call) rather than cached at module
// load, since consumers like Vue components render this markup after the
// module has already been evaluated.
function getElements() {
    return {
        freightContainer: document.getElementsByClassName('js--allowable-freight')[0],
        percent: document.getElementsByClassName('js--ob-percent')[0],
        amountLeft: document.getElementsByClassName('js--ob-amount-left')[0],
        shippingSmall: document.getElementsByClassName('js--shipping-small')[0],
        shippingLTL: document.getElementsByClassName('js--shipping-ltl')[0],
        freightAmount: document.getElementsByClassName('js--shipping-freight')[0],
    };
}

// ==================================================
// INITIALIZERS
// ==================================================

export async function fetchAndHandleAllowableFreight() {
    const { freightContainer, percent, freightAmount } = getElements();
    const { Freight, CartTotal } = await fetchCartSummary();
    const { Target: allowableFreightAmount, IsLTL, Hide = false } = Freight;

    if (!Hide) {
        freightContainer.classList.remove('none');
    } else {
        return freightContainer.classList.add('none');
    }

    const ltlActiveClass = percent.classList.contains('ob--ltl');

    if (IsLTL && !ltlActiveClass) {
        percent.classList.add('ob--ltl');
    }
    if (!IsLTL && ltlActiveClass) {
        percent.classList.remove('ob--ltl');
    }

    percent.setAttribute('data-allowable-freight', allowableFreightAmount);
    freightAmount.innerHTML = formatMoney(allowableFreightAmount);
    updateAllowableFreight({ total: 0, summary: { Freight, CartTotal } });
}

// ==================================================
// HANDLERS
// ==================================================

function updateOrderBuilderPercentBar({ CurrentTotal, Target }) {
    const { percent, amountLeft } = getElements();
    const _achievedMessage = document.getElementsByClassName('js--ob-af-achieved')[0];
    const _amountMessage = document.getElementsByClassName('js--ob-af-amount')[0];
    const percentLvl = (CurrentTotal / Target) * 100;
    const percentValue = percentLvl > 100 ? 100 : percentLvl;
    const difference = Target - CurrentTotal;
    const updatedAmountLeft = difference < 0 ? 0 : difference;
    const messages =
        updatedAmountLeft > 0
            ? [_achievedMessage, _amountMessage]
            : [_amountMessage, _achievedMessage];
    const currentPercent = Number(
        percent.style.width.substring(0, percent.style.width.length - 1),
    );

    messages[0].classList.add(hide);
    messages[1].classList.remove(hide);
    amountLeft.innerHTML = formatMoney(updatedAmountLeft);
    percent.style.width = `${percentValue}%`;
    if (percentValue > 0) {
        document.getElementsByClassName('ob__level__percent')[0].classList.add('ob__show-truck');
    } else {
        setTimeout(
            () =>
                document
                    .getElementsByClassName('ob__level__percent')[0]
                    .classList.remove('ob__show-truck'),
            2000,
        );
    }
    if (document.getElementsByClassName('ob__show-truck').length) {
        if (percentValue < currentPercent) {
            document.getElementsByClassName('ob__show-truck')[0].classList.add('reverse-truck');
        } else {
            document.getElementsByClassName('ob__show-truck')[0].classList.remove('reverse-truck');
        }
    }
}

export async function updateAllowableFreight({ total = 0, summary } = {}) {
    const { freightContainer, percent, shippingSmall, shippingLTL, freightAmount } = getElements();

    if (!freightContainer) {
        return;
    }

    const { Freight } = !summary ? await fetchCartSummary() : summary;
    const { Target, IsLTL, Hide = false } = Freight;

    if (!Hide) {
        freightContainer.classList.remove('none');
    } else {
        return freightContainer.classList.add('none');
    }

    const ltlActiveClass = percent.classList.contains('ob--ltl');

    if (IsLTL && !ltlActiveClass) {
        percent.classList.add('ob--ltl');
        shippingSmall.classList.add(hide);
        shippingLTL.classList.remove(hide);
    }
    if (!IsLTL && ltlActiveClass) {
        percent.classList.remove('ob--ltl');
        shippingLTL.classList.add(hide);
        shippingSmall.classList.remove(hide);
    }

    updateOrderBuilderPercentBar({ total, CurrentTotal: Freight.CurrentTotal, Target });

    // updateSidecart({ CartTotal, Target })
    freightAmount.innerHTML = formatMoney(Target);
}

// ==================================================
// HELPERS
// ==================================================

// ==================================================
// INIT
// ==================================================

function init() {
    // fetchAndHandleAllowableFreight()
}

export default init;
